import React, { useState } from 'react';
import { AppSection } from '../types';
import Logo from './Logo';

interface HeaderProps {
  activeSection: AppSection;
  onNavigate: (section: AppSection) => void;
  onContactClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ activeSection, onNavigate, onContactClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { id: AppSection.Home, label: 'Home' },
    { id: AppSection.Solutions, label: 'Solutions' },
    { id: AppSection.Talent, label: 'Talent' },
    { id: AppSection.CaseStudies, label: 'Case Studies' },
    { id: AppSection.About, label: 'About' },
  ];

  const handleNavigate = (id: AppSection) => {
    onNavigate(id);
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-[60] bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div 
          className="flex items-center space-x-3 cursor-pointer group"
          onClick={() => handleNavigate(AppSection.Home)}
        >
          <Logo className="w-8 h-8 group-hover:scale-105 transition-transform" />
          <span className="text-xl font-bold tracking-tight text-slate-900 group-hover:text-[#0091da] transition-colors uppercase">
            HUNARGRID
          </span>
        </div>
        
        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center space-x-8">
          {navItems.map((item) => (
            <button 
              key={item.id}
              onClick={() => handleNavigate(item.id)} 
              className={`text-sm font-semibold transition-colors flex items-center ${activeSection === item.id ? 'text-[#0091da]' : 'text-slate-600 hover:text-[#0091da]'}`}
            >
              {item.label}
            </button>
          ))}
          <button 
            onClick={onContactClick}
            className="bg-slate-900 text-white text-xs font-bold uppercase tracking-widest px-6 py-2 rounded-sm hover:bg-[#0091da] transition-all"
          >
            Contact Us
          </button>
        </nav>

        {/* Mobile Toggle */}
        <button className="lg:hidden p-2 text-slate-600 z-[70]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>
      </div>

      {/* Mobile Drawer */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 top-16 z-[50] bg-white animate-in slide-in-from-top-4 duration-200 ease-out h-screen overflow-hidden">
          <nav className="flex flex-col p-8 space-y-6 bg-white h-full shadow-2xl relative">
            {navItems.map((item) => (
              <button 
                key={item.id}
                onClick={() => handleNavigate(item.id)} 
                className={`text-2xl font-bold text-left transition-colors pb-4 border-b border-slate-50 flex items-center justify-between ${activeSection === item.id ? 'text-[#0091da]' : 'text-slate-900'}`}
              >
                {item.label}
              </button>
            ))}
            <button 
              onClick={() => { onContactClick(); setIsMobileMenuOpen(false); }}
              className="w-full bg-slate-900 text-white py-5 mt-4 font-bold uppercase tracking-widest text-sm rounded-sm"
            >
              Contact Us
            </button>
            <div className="mt-auto pb-32 pt-10 border-t border-slate-100 flex items-center space-x-4">
              <Logo className="w-6 h-6 opacity-50" />
              <span className="mono text-[10px] text-slate-400 uppercase tracking-widest">Precision_Engine // V1.0</span>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;